import { Injectable } from '@angular/core';
import { TypeAutresInfosATTR } from '../../models/TypeAutresInfosATTR';
import { TypeMontant } from '../../models/TypeMontant';

@Injectable({
  providedIn: 'root'
})
export class AutresInformationsService {

  constructor() {
  }

  public getAutreInformations(controls, stepId): TypeAutresInfosATTR {
    const autresInformations = new TypeAutresInfosATTR();
    if(stepId === 6) {
      autresInformations.informations = controls.get('_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepAtt_informations');
      autresInformations.nbOffresRecues = controls.get('_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepAtt_nbOffresRecues');
    }
    if (stepId === 2) {
      const dateAttribution = '_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepAtt_dateAttribution';
      autresInformations.dateAttribution = controls.get(dateAttribution) + controls.get(dateAttribution + '_timestamp');
      autresInformations.nbParticipants = controls.get('_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepAtt_nbParticipants');
      autresInformations.nbParticipantsEtrangers = controls.get('_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepAtt_nbParticipantsEtrangers');
      autresInformations.primeAttribuee = new TypeMontant();
      autresInformations.primeAttribuee.devise = controls.get('_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepSep_TypeMontant_SepAtt_devise');
      autresInformations.primeAttribuee.valeur = controls.get('_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepSep_TypeMontant_SepAtt_valeur');
      autresInformations.valeurTotaleEstimee = new TypeMontant();
      autresInformations.valeurTotaleEstimee.devise = controls.get('_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepSep_valeurTotaleEstimee_SepSep_TypeMontant_SepAtt_devise');
      autresInformations.valeurTotaleEstimee.valeur = controls.get('_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepSep_valeurTotaleEstimee_SepSep_TypeMontant_SepAtt_valeur');
    }
    return autresInformations;
  }
}
